/**
 * Helper utilities for calculating battery scores (Risk & Sector Cycle)
 */

const getPerf = (data, activePeriod, ticker) => {
    for (let cat of data) {
        let asset = cat.assets.find(a => a.ticker === ticker);
        if (asset) return asset.performance[activePeriod] || 0;
    }
    return 0;
};

export const calculateRiskScore = (data, activePeriod) => {
    let riskScore = 0;
    
    // Risk Battery Calculation (Cross Asset)
    const spx = getPerf(data, activePeriod, 'S&P500');
    const ndx = getPerf(data, activePeriod, 'NASDAQ');
    const vix = getPerf(data, activePeriod, 'VIX');
    const usdx = getPerf(data, activePeriod, 'USDX');
    const btc = getPerf(data, activePeriod, 'BTCUSD');

    if (spx > 0) riskScore++; else if (spx < 0) riskScore--;
    if (ndx > 0) riskScore++; else if (ndx < 0) riskScore--;
    if (vix < 0) riskScore++; else if (vix > 0) riskScore--;
    if (usdx < 0) riskScore++; else if (usdx > 0) riskScore--;
    if (btc > 0) riskScore++; else if (btc < 0) riskScore--;

    return riskScore;
};

export const calculateCycleScore = (data, activePeriod) => {
    let cycleScore = 0;

    // Sector Cycle Battery Calculation (Cross Sector)
    // Cyclicals (Expansion)
    const xlk = getPerf(data, activePeriod, 'XLK');
    const xly = getPerf(data, activePeriod, 'XLY');
    const xli = getPerf(data, activePeriod, 'XLI');
    // Defensives (Contraction)
    const xlu = getPerf(data, activePeriod, 'XLU');
    const xlp = getPerf(data, activePeriod, 'XLP');
    const xlv = getPerf(data, activePeriod, 'XLV');

    if (xlk > 0) cycleScore++; else if (xlk < 0) cycleScore--;
    if (xly > 0) cycleScore++; else if (xly < 0) cycleScore--;
    if (xli > 0) cycleScore++; else if (xli < 0) cycleScore--;
    if (xlu < 0) cycleScore++; else if (xlu > 0) cycleScore--;
    if (xlp < 0) cycleScore++; else if (xlp > 0) cycleScore--;
    if (xlv < 0) cycleScore++; else if (xlv > 0) cycleScore--;

    return cycleScore;
};
